<mat-toolbar id="footer">
    <div fxLayout="row" fxLayoutAlign="center center" fxLayoutAlign.gt-xs="space-between center" fxFlex>
        <div class="m-0 p-16" fxLayout="row wrap" fxFlex="50" fxLayoutAlign="start center">
            <div *ngIf="mostrarAsignar" class="px-8">
                <button mat-stroked-button class="btnTerciario" (click)="asignarEmit()">
                    {{textoAsignar}}
                </button>
            </div>
            <div *ngIf="atras">
                <button mat-stroked-button class="btnSecundario" (click)="atrasEmit()">
                    <mat-icon>arrow_back</mat-icon>
                </button>
            </div>
        </div>

        <div class="m-0 p-16" fxLayout="row wrap" fxFlex="50" fxLayoutAlign="end center">
            <div class="px-8">
                <button *ngIf="textoCancelar" mat-stroked-button class="btnSecundario" (click)="cancelarEmit()">
                    {{textoCancelar}}
                </button>
            </div>
            <div class="px-8">
                <button *ngIf="textoGuardar" mat-stroked-button class="btnPrimario" (click)="aceptarEmit()">
                    {{textoGuardar}}
                </button>
            </div>
            <div class="px-8">
                <button *ngIf="adelante" mat-stroked-button class="btnSecundario" (click)="adelanteEmit()">
                    <mat-icon>arrow_forward</mat-icon>
                </button>
            </div>
        </div>
    </div>

</mat-toolbar>